export default __webpack_public_path__ + "static/media/icon-edit.1b27c0c9.svg";